import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { sessionContainer } from 'src/models'

function AppInitializer() {
  const history = useHistory()
  const location = useLocation()

  // Mount-only: boot runs once with the initial location (CSR ?token= is read from landing URL).
  useEffect(() => {
    if (!sessionContainer.shouldRunBootEffects()) {
      return
    }

    let cancelled = false

    sessionContainer
      .bootFromRoute(history, location, {
        isCancelled: () => cancelled,
      })
      .catch(err => console.error('[AppInitializer] boot failed:', err))

    return () => {
      cancelled = true
    }
  }, [])

  return null
}

export default AppInitializer
export { AppInitializer }
